export const EVENT = {
  UPDATE_PRIZE_STATUS: 'updatePrizeStatus',
  HIDE_LOTTERY_ENTRY: 'hideLotteryEntry',
  SCREEN_ROTATE: 'screeRotate',
  SHOW_ORDER_MODAL: 'SHOW_ORDER_MODAL',
  REFRESH_USER_CURRENCY: 'REFRESH_USER_CURRENCY',
  INVOKE_LOTTERY_START: 'INVOKE_LOTTERY_START',
  INVOKE_LOTTERY_END: 'INVOKE_LOTTERY_END',
  LOTTERY_ANIMATE_FINISH: 'LOTTERY_ANIMATE_FINISH',
  SHOW_ACTIVE_BUTTON: 'SHOW_ACTIVE_BUTTON',
  START_FREE_LOTTERY: 'START_FREE_LOTTERY',
  SHOW_FESTIVAL_LOTTERY_FLOAT: 'SHOW_FESTIVAL_LOTTERY_FLOAT',
};
